export default "__VITE_ASSET__d64315c0__"